import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import FormService from "../../../services/FormService";
import Skeleton from "@material-ui/lab/Skeleton";
import useError from "../../../util/hooks/use-error";
import Container from "../../../components/layouts/Container";
import FileCopyTwoToneIcon from "@material-ui/icons/FileCopyTwoTone";
import { motion } from "framer-motion";
const useStyles = makeStyles((theme) => ({
    rootPC: {
        color: theme.palette.text.primary,
        width: "90%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        borderRadius: "5px",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "1rem",
        padding: "0rem .5rem",
        "& .MuiDivider-root": {
            border: "none",
            height: "1px",
            width: "100%",
            margin: 0,
            backgroundColor: theme.palette.text.disabled,
            opacity: "0.3",
        },

        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            flexWrap: "wrap",
            width: "100%",
            borderRadius: "20px",
            padding: "1.5rem 2.5rem 1.5rem 2.5rem",
        },
    },

    download_card: {
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "15rem",
        height: "10rem",
        borderRadius: "10px",
        margin: "1rem",
        padding: "0.5rem",
        boxShadow: "3px 3px 6px rgba(0,0,0,0.2)",
        transition: ".3s ease-out",
        "& .icon": {
            transition: ".3s ease-out",
            fontSize: "4rem",
            color: theme.palette.text.secondary,
            flex: 1,
        },
        "& .title": {
            color: theme.palette.text.secondary,
            textAlign: "center",
        },
        "&:hover": {
            transform: "scale(1.03)",
            backgroundColor: theme.palette.primary.light,

            "& .icon": {
                fontSize: "4.5rem",
                color: theme.palette.primary.main,
            },
            "& .title": {
                color: theme.palette.primary.main,
            },
        },
        "@media (max-width:768px)": {
            flexDirection: "row",
            width: "100vw",
            height: "4rem",
            margin: 0,
            borderRadius: "0px",
            "& .icon": {
                transition: ".3s ease-out",
                fontSize: "2.5rem",
                color: theme.palette.text.secondary,
                flex: 0.3,
            },
            "& .title": {
                flex: 1,
                textAlign: "left",
                margin: "0 1rem",
            },
            "&:hover": {
                "& .icon": {
                    fontSize: "3.5rem",
                    color: theme.palette.primary.main,
                },
            },
        },
    },
}));
function Passport() {
    const classes = useStyles();
    const { errorHandler } = useError();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        FormService.getFormList()
            .then((res) => {
                console.log(res.data);
                let temp = [];
                res.data = res.data.filter((data) => data.type === "passport");
                res.data.forEach((row) => {
                    temp.push(createRow(row));
                });

                setRows(temp);
                setLoading(false);
            })
            .catch((err) => errorHandler(err));
    }, [errorHandler]);

    const createRow = (row) => {
        const title = row.title;
        const file_name = row.file.filename;
        const file_location = row.file.file_location;
        return {
            data: {
                title: title,
                file_name: file_name,
                file_location: file_location,
            },
        };
    };
    return (
        <Container>
            <List
                component="nav"
                className={classes.rootPC}
                aria-label="contacts"
            >
                {loading ? (
                    [0, 1, 2, 3, 4].map((row) => (
                        <div>
                            <a className={classes.download_card} href="/">
                                <FileCopyTwoToneIcon className="icon" />
                                <h4 className="title">
                                    <Skeleton width="10rem" />
                                </h4>
                            </a>
                        </div>
                    ))
                ) : (
                    <motion.div
                        style={{ display: "flex", flexWrap: "wrap" }}
                        variants={{
                            hidden: { opacity: 1 },
                            show: {
                                opacity: 1,
                                transition: {
                                    staggerChildren: 0.1,
                                },
                            },
                        }}
                        initial="hidden"
                        animate="show"
                    >
                        {rows.map((row) => (
                            <motion.div
                                variants={{
                                    hidden: { opacity: 0, scale: 0 },
                                    show: {
                                        opacity: 1,
                                        scale: 1,
                                        transition: { duration: 0.5 },
                                    },
                                }}
                            >
                                <a
                                    className={classes.download_card}
                                    href={row.data.file_location}
                                    download={row.data.file_name}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <FileCopyTwoToneIcon className="icon" />
                                    <h4 className="title">{row.data.title}</h4>
                                </a>
                            </motion.div>
                        ))}
                    </motion.div>
                )}
            </List>
        </Container>
    );
}

export default Passport;
